import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { User } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import UserForm from '@/components/users/UserForm.vue';
    import { RoleOption } from '@/types';
    import { useI18n } from 'vue-i18n';
    import ToggleActivationUser from './ToggleActivationUser.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditUser',
  props: {
    user: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const form = useForm({
        name: props.user.name,
        email: props.user.email,
        phone: props.user.phone,
        role_ids: props.user.roles.map((role) => ({
            id: role.id,
            name: role.name,
            company_id: role.pivot.company_id,
        })),
        company_ids: props.user.companies.map((company) => company.id.toString()),
        contact_persons: props.user.contact_person_companies.map((company) =>
            company.id.toString(),
        ),
        language: props.user.language,
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    key: _ctx.user.id,
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.users.update', _ctx.user.id),
    "query-key": [_unref(QueryKey).USERS],
    title: "users.edit_txt",
    "modal-size": "sm:max-w-xl",
    "success-message-translated": _unref(t)('users.update.success', { username: _unref(form).name }),
    transform: 
            (data) => ({
                ...data,
                role_ids: data.role_ids.map((role) => `${role.company_id}_${role.id}`),
            })
        
  }, {
    footerActions: _withCtx(() => [
      _createVNode(ToggleActivationUser, { user: _ctx.user }, null, 8, ["user"])
    ]),
    default: _withCtx(() => [
      _createVNode(UserForm, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key", "success-message-translated", "transform"]))
}
}

})